/* mm-altbilgi.js — <1024 tek açık akordeon (sütun başlıkları), dil/ülke seçici açılır listesi (Shopify yerelleştirme formu). */
(() => {
  const mq = window.matchMedia('(min-width: 1024px)');

  function akordeon(kok) {
    const trigs = [...kok.querySelectorAll('[data-mm-trig]')];
    const sutun = (t) => t.closest('.mm-ftr__col');
    const ayarla = () => trigs.forEach((t) => {
      if (mq.matches) { t.setAttribute('tabindex', '-1'); t.removeAttribute('aria-expanded'); }
      else { t.removeAttribute('tabindex'); t.setAttribute('aria-expanded', sutun(t).classList.contains('is-open') ? 'true' : 'false'); }
    });
    const ac = (hedef, acik) => trigs.forEach((t) => {
      const on = t === hedef && acik;
      sutun(t).classList.toggle('is-open', on);
      if (!mq.matches) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    trigs.forEach((t) => t.addEventListener('click', () => {
      if (mq.matches) return;
      ac(t, !sutun(t).classList.contains('is-open'));
    }));
    mq.addEventListener('change', ayarla);
    ayarla();
    return { trigs, ac };
  }

  function dilSecici(kok) {
    const dil = kok.querySelector('[data-mm-dil]');
    if (!dil) return;
    const btn = dil.querySelector('[data-mm-dil-ac]');
    const pop = dil.querySelector('[data-mm-dil-pop]');
    const form = dil.querySelector('form');
    if (!btn || !pop || !form) return;
    const kapat = () => { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); };
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const acilacak = pop.hidden;
      pop.hidden = !acilacak;
      btn.setAttribute('aria-expanded', acilacak ? 'true' : 'false');
      if (acilacak) (pop.querySelector('[aria-current="true"]') || pop.querySelector('button'))?.focus();
    });
    pop.addEventListener('click', (e) => {
      const o = e.target.closest('[data-alan]');
      if (!o) return;
      const inp = form.querySelector(`input[name="${o.dataset.alan}"]`);
      if (inp) inp.value = o.dataset.deger;
      form.submit();
    });
    document.addEventListener('click', (e) => { if (!pop.hidden && !dil.contains(e.target)) kapat(); });
    dil.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) { kapat(); btn.focus(); } });
  }

  function kur(kok) {
    if (kok.dataset.mmKurulu) return;
    kok.dataset.mmKurulu = '1';
    const a = akordeon(kok);
    dilSecici(kok);
    // Tema düzenleyicide blok seçilince ilgili sütunu aç
    kok.addEventListener('shopify:block:select', (e) => {
      const t = e.target.querySelector && e.target.querySelector('[data-mm-trig]');
      if (t && !mq.matches) a.ac(t, true);
    });
  }
  const hepsi = () => document.querySelectorAll('[data-mm="altbilgi"]').forEach(kur);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
  document.addEventListener('shopify:section:load', hepsi);
})();
